/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleGetterContext, moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
// import * as types from '@/lib/definition/types'
import moment from "moment-timezone";
moment.locale('ja')

export interface GithubState {
  [key: string]: any;
}

const Github = defineModule({
  state: (): GithubState => {
    return {
    }
  },
  getters: {
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    }
  },
  actions: {
    async auth(context): Promise<any> {
      const { rootState } = moduleActionContext(context, Github)
      var api = Lib.Ajax.apiUrl('/api/github/auth_start/' + rootState.Login.userInfo.aspNetId)
      window.location.href = api
    },
    async add(context, { endedTimeGMT, message, url, color, targetTagId, GithubId }): Promise<any> {
      const { rootState } = moduleActionContext(context, Github)
      const retval = await Lib.Ajax.getHandleError<any>('/api/Github/add/' + GithubId, "Failed to receive Groups", { endedTimeGMT, message, url, color, targetTagId }, rootState.Login.accessToken)
      var groups = retval.data.data
      return groups
    },
    async delete(context, GithubId): Promise<any> {
      const { rootState } = moduleActionContext(context, Github)
      const retval = await Lib.Ajax.getHandleError<any>('/api/Github/delete/' + GithubId, "Failed to Delete Information ", {}, rootState.Login.accessToken)
      var groups = retval.data.data
      return groups
    },
    async finish(context, GithubId): Promise<any> {
      const { rootState } = moduleActionContext(context, Github)
      const retval = await Lib.Ajax.getHandleError<any>('/api/Github/finish/' + GithubId, "Failed to Finish Information", {}, rootState.Login.accessToken)
      var groups = retval.data.data
      return groups
    },
    async listAll(context): Promise<any> {
      const { rootState } = moduleActionContext(context, Github)
      const retval = await Lib.Ajax.getHandleError<any>('/api/Github/listall', "Failed to receive Groups", {}, rootState.Login.accessToken)
      var list = retval.data.data
      list.forEach((element: any) => {
        element.endedGMTM = element.endedTimeGMT == null ? null : moment.tz(element.endedTimeGMT, 'Etc/GMT')
        element.ended = element.endedTimeGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('YYYY-MM-DD HH:mm')
        element.endedShort = element.endedTimeGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('MM/DD dd HH:mm')
        element.endedDate = element.endedTimeGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('YYYY-MM-DD')
        element.endedTime = element.endedTimeGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('HH:mm')
        element.endedTime2 = element.endedTimeGMT == null ? null : element.endedGMTM.tz(moment.tz.guess()).format('HH:mm')
        element.endedClientM = element.endedTimeGMT == null ? null : moment(element.endedClient)
        element.endedClientF = element.endedTimeGMT == null ? null : element.endedClientM.format('YYYY-MM-DD HH:mm')  
      });
      return list
    },
    async disconnect(context): Promise<any> {
      const { rootState } = moduleActionContext(context, Github)
      const retval = await Lib.Ajax.postHandleError<any>('/api/github/disconnect', "Failed to disconnect GitHub", {}, rootState.Login.accessToken)
      return retval.data.data
    },
    },
  namespaced: true
})

export default Github
const loginGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, Github)

























